import React from "react";

import { Box, MenuItem, TextField } from "@mui/material";

import { CATEGORIES, MAX_METADATA_LENGTH } from "@/util/constants";

import styles from "./TeamsIntegrationModalMetadataForm.module.scss";

type TeamsIntegrationMetadataFormProps = {
  handleFileCategoryChange: (_category: string) => void;
  fileCategory: string;
  metadata: string;
  handleMetadataChange: (_metadata: string) => void;
};

export const TeamsIntegrationModalMetadataForm: React.FC<TeamsIntegrationMetadataFormProps> = ({
  handleFileCategoryChange,
  handleMetadataChange,
  metadata,
  fileCategory,
}) => {
  return (
    <Box className={styles.formDetails}>
      <span className={styles.title}>Details</span>
      <Box className={styles.flexContainer}>
        <span className={styles.description}>Provide the file details.</span>
        <span>
          <span className={styles.requiredIndicator}>*</span>Indicates required
        </span>
      </Box>
      <Box className={styles.formFields}>
        <Box className={styles.fieldContainer}>
          <span>
            <span className={styles.requiredIndicator}>*</span>File category
          </span>
          <TextField
            color="success"
            select
            label="Select"
            fullWidth
            margin="normal"
            variant="outlined"
            value={fileCategory}
            size="small"
            inputProps={{ "data-testid": "categorySelector" }}
            onChange={(e) => {
              handleFileCategoryChange(e.target.value);
            }}
          >
            {CATEGORIES.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box className={styles.fieldContainer}>
          <span>Metadata</span>
          <TextField
            color="success"
            label="Type"
            fullWidth
            multiline
            rows={4}
            value={metadata}
            margin="normal"
            variant="outlined"
            onChange={(e) => {
              handleMetadataChange(e.target.value);
            }}
            inputProps={{
              "data-testid": "metadataField",
              maxLength: MAX_METADATA_LENGTH,
            }}
            placeholder="Metadata improves AI search by adding context with keywords and descriptions, making search results more relevant and responses better."
          />
          <Box className={styles.textCounterContainer}>
            {metadata?.length ?? 0} / {MAX_METADATA_LENGTH}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
